import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-green-500';
    if (trend === 'new') return 'ri-sparkling-line text-accent-500';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-trophy-line"></i>
            实时榜单
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热播榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            最受瞩目的影视作品热度排行
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {rankingData.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl hover:bg-background-200/50 transition-colors group cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading font-bold text-lg flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-foreground-900 font-semibold text-sm md:text-base whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-foreground-400 text-xs bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <p className="text-foreground-500 text-xs md:text-sm truncate">{item.desc}</p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-accent-500 font-bold text-base md:text-lg">{item.score}</span>
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={getTrendIcon(item.trend)}></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}